module.exports = "<div class=\"alert-message-icon {{icon}}\">\n    <h3 ><span [innerHtml]=\"text\">{{text}}</span></h3>\n</div>\n"